var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"answer",on:{"click":function($event){return _vm.handleAnswer()}}},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":_vm.icon,"alt":_vm.answer.icon}})]),_c('div',{staticClass:"label"},[_vm._v(" "+_vm._s(_vm.answer.answer)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }